import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const UserHexagonOutline = createIcon({
  displayName: 'UserHexagonOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M3 14.319v-4.762c0-1.602.852-3.083 2.236-3.889l4.5-2.619c1.399-.814 3.128-.814 4.527 0l4.5 2.619c1.385.806 2.237 2.287 2.237 3.889v4.762c0 1.602-.852 3.083-2.236 3.889l-4.5 2.619c-1.399.814-3.128.814-4.527 0l-4.5-2.619c-1.385-.806-2.237-2.287-2.237-3.889Z" />
        <path d="M12 7.938c1.227 0 2.222.995 2.222 2.222 0 1.227-.995 2.222-2.222 2.222 -1.227 0-2.222-.995-2.222-2.222 0-1.227.995-2.222 2.222-2.222" />
        <path d="M16 15.938c-.116-.293-.297-.555-.528-.769v0c-.391-.362-.901-.564-1.434-.564 -.889 0-3.186 0-4.075 0 -.533 0-1.044.202-1.435.564v0c-.231.213-.411.476-.528.769" />
      </g>
      <rect xmlns="http://www.w3.org/2000/svg" width="24" height="24" y="-.062" fill="none" />
    </>
  ),
})

const UserHexagonTwoTone = createIcon({
  displayName: 'UserHexagonTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="g"
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="twoToneStrokeColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M3 14.319v-4.762c0-1.602.852-3.083 2.236-3.889l4.5-2.619c1.399-.814 3.128-.814 4.527 0l4.5 2.619c1.385.806 2.237 2.287 2.237 3.889v4.762c0 1.602-.852 3.083-2.236 3.889l-4.5 2.619c-1.399.814-3.128.814-4.527 0l-4.5-2.619c-1.385-.806-2.237-2.287-2.237-3.889Z" />
        <path d="M12 7.938c1.227 0 2.222.995 2.222 2.222 0 1.227-.995 2.222-2.222 2.222 -1.227 0-2.222-.995-2.222-2.222 0-1.227.995-2.222 2.222-2.222" />
        <path d="M16 15.938c-.116-.293-.297-.555-.528-.769v0c-.391-.362-.901-.564-1.434-.564 -.889 0-3.186 0-4.075 0 -.533 0-1.044.202-1.435.564v0c-.231.213-.411.476-.528.769" />
      </Box>
      <rect xmlns="http://www.w3.org/2000/svg" width="24" height="24" y="-.062" fill="none" />
    </>
  ),
})

const UserHexagon: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={UserHexagonTwoTone} {...props} />
  return <CustomIcon as={UserHexagonOutline} {...props} />
}

export default memo(UserHexagon)
